import { generateUtilityClasses } from '@mui/material';

export const stackClasses = generateUtilityClasses('Stack', ['root']);

export type StackClasses = typeof stackClasses;
